const FLOW_TRACE_ID = /^[A-Z][A-Z0-9._-]{2,119}$/;

export function flowTraceIdFromMap(
  values: Record<string, unknown> | null | undefined
): string | null {
  const value = values?.flowTraceId;
  if (typeof value !== "string") return null;
  const normalized = value.trim();
  return FLOW_TRACE_ID.test(normalized) ? normalized : null;
}
